import { render } from "./accessories.vue?vue&type=template&id=b7475518&scoped=true&ts=true"
import script from "./accessories.vue?vue&type=script&lang=ts"
export * from "./accessories.vue?vue&type=script&lang=ts"

import "./accessories.vue?vue&type=style&index=0&id=b7475518&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7475518"]])

export default __exports__